import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import { Avatar, Stack, Typography } from "@mui/material";

interface AuthorizationGroupItemProps {
  name: string;
  memberCount: number;
  iconSize: "small" | "medium";
}
const AuthorizationGroupItem = ({ name, memberCount, iconSize }: AuthorizationGroupItemProps) => {
  const avatarSizeValue = iconSize === "small" ? 24 : 32;
  const iconSizeValue = iconSize === "small" ? 16 : 24;

  return (
    <Stack direction={"row"} spacing={1.5} sx={{ alignItems: "center" }}>
      <Avatar sx={{ width: avatarSizeValue, height: avatarSizeValue }}>
        <PeopleOutlinedIcon sx={{ width: iconSizeValue, height: iconSizeValue, color: "secondary.main" }} />
      </Avatar>
      <Stack>
        <Typography variant="body2">{name}</Typography>
        <Typography variant="caption" color="textSecondary">
          {memberCount} {memberCount === 1 ? "member" : "members"}
        </Typography>
      </Stack>
    </Stack>
  );
};
export default AuthorizationGroupItem;
